export class IdValidator {
  /**
   * For use in extended unicode mode /v.
   * Hyphen (-) is escaped twice to avoid browser errors when using the expression for html input's pattern attribute.
   * Instantiating a RegExp will unescape the hyphen, but extended unicode mode (/v) requires the hyphen to be escaped.
   * Therefore, we escape it twice.
   */
  public static readonly pattern = '^[a-z0-9_.\\-]+$'
}
